import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  OrdersPort,
  ReceivedOrdersPort
} from '@service/preclinical/orders.port';
import { IngestedOrdersService } from '@infra-services/ingested-orders/services/ingested-orders.service';
import { ReceivedOrdersService } from '@infra-services/received-orders/services/received-orders.service';
import {
  IngestedOrder,
  ReceivedOrder,
  IngestedOrdersQueryParams
} from '@model/ingested-order/ingested-order.model';
import { FilterOptionsResponse } from '@model/filter/filter-options.model';

@Injectable({
  providedIn: 'root'
})
export class IngestedOrdersAdapter implements OrdersPort {
  private readonly ordersService = inject(IngestedOrdersService);

  getOrders(params?: IngestedOrdersQueryParams): Observable<{
    orders: IngestedOrder[] | ReceivedOrder[];
    pagination: {
      page: number;
      size: number;
      total: number;
      totalPages: number;
    };
  }> {
    return this.ordersService.getOrders(params);
  }

  getFilterOptions(): Observable<FilterOptionsResponse> {
    return this.ordersService.getFilterOptions();
  }
}

@Injectable({
  providedIn: 'root'
})
export class ReceivedOrdersAdapter implements ReceivedOrdersPort {
  private readonly ordersService = inject(ReceivedOrdersService);

  getOrders(params?: IngestedOrdersQueryParams): Observable<{
    orders: IngestedOrder[] | ReceivedOrder[];
    pagination: {
      page: number;
      size: number;
      total: number;
      totalPages: number;
    };
  }> {
    return this.ordersService.getOrders(params);
  }

  getFilterOptions(): Observable<FilterOptionsResponse> {
    return this.ordersService.getFilterOptions();
  }

  finalSave(caseNumbers: string[]): Observable<{
    specimenCount: number;
    message: string;
    timestamp: string;
    username: string;
  }> {
    return this.ordersService.finalSave(caseNumbers);
  }
}
